import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useVerificationsRedux, VerificationsReducer } from "../../redux";
import { VerificationSearch } from "./VerificationSearch";
import { VerificationResult } from "./VerificationResult";
import { VerificationNotFound } from "./VerificationNotFound";
import { VerificationGetRequest } from "../../models";

export const VerificationsPage = () => {

    const navigate = useNavigate();
    const [lastName, setLastName] = useState<string>(``);
    const [firstName, setFirstName] = useState<string>('');
    const [middleInitial, setMiddleInitial] = useState<string>('');
    const [birthMonth, setBirthMonth] = useState<string>('');
    const [birthDay, setbirthDay] = useState<string>('');
	const [birthYear, setBirthYear] = useState<string>('');

    const verificationRedux = useVerificationsRedux();

    const submitSearch = (request: VerificationGetRequest) => {       
        verificationRedux.loadVerification(request);
    }

    const couldntFindUser = () : boolean => {
        return verificationRedux.state.error?.status === 500 && verificationRedux.state.error?.detail === `Exception of type 'Ucsb.Sa.Enterprise.HttpClientSa.SaNotFoundException' was thrown.`
    }

    return (<>
    { couldntFindUser() ? <VerificationNotFound  startOver={()=> verificationRedux.verificationStartOver()}  /> : ""}
        {!couldntFindUser() ? verificationRedux.state.verification 
        ? 
            <VerificationResult
            searchName={verificationRedux.state.searchName}
            verification={verificationRedux.state.verification}
            startOver={()=>{verificationRedux.verificationStartOver()}}
             />
        :
        <VerificationSearch
            BirthDayUpdated={(e: React.ChangeEvent<HTMLSelectElement>) => setbirthDay(e.target.value)}
            BirthMonthUpdated={(e: React.ChangeEvent<HTMLSelectElement>) => setBirthMonth(e.target.value)}
            FirstNameUpdated={(value: string, e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setFirstName(value)}
            LastNameUpdated={(value:string, e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setLastName(value)}
            birthYearUpdated={(value:string, e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setBirthYear(value)}
            MiddleInitialUpdated={(value: string, e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setMiddleInitial(value.length > 0 ? value.slice(0,1) : value)}
            SubmitSearch={submitSearch}
            birthDay={birthDay}
            birthMonth={birthMonth}
            firstName={firstName}
            lastName={lastName}
            middleInitial={middleInitial}
            birthYear={birthYear}
         />
        : <></>}
    </>);
};
export default VerificationsPage;